import {createContext} from "react";

type QRCodeViewSortingContextType = {
    /**
     * Is popover opened?
     * @since 0.1.9
     * @author Kacper Faber
     */
    opened: boolean;

    /**
     * Change the open state.
     * You can use it if user clicked the item.
     * @since 0.1.9
     * @author Kacper Faber
     */
    setOpened: (isOpened: boolean) => void;
};

/**
 * Default values
 * @since 0.1.9
 * @author Kacper Faber
 */
const defaults: QRCodeViewSortingContextType = {
    opened: false,
    setOpened: () => { throw new Error('Not implemented'); }
}

const ctx = createContext<QRCodeViewSortingContextType>(defaults);

export default ctx;